module.exports = __webpack_public_path__ + "static/media/mp3.a28bccd4.svg";